module.exports = __webpack_public_path__ + "static/img/turntable.c076b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/turntable.png
// module id = ZmLJ
// module chunks = 43